import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Checkbox from "components/checkbox";
import { loginApi } from "services/api/loginApi";


export default function SignIn() {

  const navigate = useNavigate();


  const [loginValue, setLoginValue] = useState("");

  const [password, setPassword] = useState("");

  const [keepLoggedIn, setKeepLoggedIn] = useState(true);

  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("BUTTON CLICKED");
    console.log({
      loginValue,
      password
    });

    if (!loginValue) {
      setErrorMessage("Email is required");
      return;
    }

    if (!password) {
      setErrorMessage("Password is required");
      return;

    }
    try {
      setLoading(true);
      setErrorMessage("");

      const result = await loginApi({

          login: loginValue.trim(),

          password: password.trim()

      });

      console.log("API RESPONSE", result);

      const userData = result.data;

      localStorage.clear();

      localStorage.setItem(
        "accessToken",
        userData.accessToken
      );


      localStorage.setItem(
        "refreshToken",
        userData.refreshToken
      );


      localStorage.setItem(
        "user",
        JSON.stringify(
          userData.user
        )
      );



      console.log(
        "SAVED USER",
        userData.user
      );



      navigate(
        "/admin/default",
        {
          replace: true
        }
      );



    }
    catch (error) {

      console.log("LOGIN ERROR", error);

      setErrorMessage(
        error.response?.data?.message ||
        "Login failed"
      );

    }
    finally {
      setLoading(false);
    }
  };

  return (

    <div className="flex min-h-screen items-center justify-center">

      <div className="w-full max-w-md">

        <h2 className="mb-5 text-3xl font-bold">
          Sign In
        </h2>

        {
          errorMessage &&
          <div className="mb-3 rounded bg-red-100 p-3 text-red-600">

            {
              Array.isArray(errorMessage)
                ?
                errorMessage.join(", ")
                :
                errorMessage
            }

          </div>
        }

        <form onSubmit={handleLogin}>

          <input

            className="mb-4 w-full rounded border p-3"

            placeholder="Email"

            value={loginValue}

            onChange={(e) =>
              setLoginValue(
                e.target.value
              )
            }

          />

          <input

            className="mb-4 w-full rounded border p-3"

            type="password"

            placeholder="Password"

            value={password}

            onChange={(e) =>
              setPassword(
                e.target.value
              )
            }

          />

          <div className="mb-4 flex">

            <Checkbox

              checked={keepLoggedIn}

              onChange={() =>
                setKeepLoggedIn(
                  !keepLoggedIn
                )
              }

            />

            <span className="ml-2">
              Keep me logged in
            </span>


          </div>

          <button

            type="submit"

            disabled={loading}

            className="w-full rounded-xl bg-brand-500 py-3 text-white"

          >

            {
              loading
                ?
                "Signing..."
                :
                "Sign In"
            }


          </button>

        </form>

      </div>

    </div>

  );

}